import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ChevronRight, Award } from 'lucide-react';
import styled from 'styled-components';

import { getRecognitionWall, RECOGNITION_BADGE_MAP } from '../../recognitions/config';
import { formatDate } from '../../../utils/Utils';
import {
  Card,
  CardHeader,
  CardTitle,
  EmptyState,
  ScrollList,
  ListItem,
  ListItemContent,
  ListItemName,
  ListItemSub,
} from '../styles';

// Faz D (spec 2026-08-08 §4, Task 5, D5) — AnnouncementsCard.js ile BİREBİR
// AYNI iskelet (desen aynası): tıklanabilir başlık + "Tümünü Gör" + kaydırılan
// liste + boş-durum. Son 5 PUBLIC takdir — GET v1/recognitions/wall (YALNIZ
// isPublic:true, sahiplik aramaz, task-3-report.md §1); tıklanınca
// /performance/recognitions'a gider. Rozet ikon+gradyanı recognitions/config'ten
// (AnnouncementsCard'ın ../../announcements/config'ten getMyAnnouncements
// import etmesiyle AYNI cross-page-group desen; HaIntelligencePanel de
// ../../hr-analytics/config'ten import ediyor — repo genelinde kurulu).
const ClickableHeader = styled(CardHeader)`
  cursor: pointer;
  user-select: none;
`;

const HeaderLink = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.colors.primary.main};
  font-size: 12px;
  font-weight: 600;
`;

const BadgeTile = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${({ $from, $to }) => `linear-gradient(135deg, ${$from || '#0291EF'}, ${$to || '#38BDF8'})`};
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
`;

const MAX = 5;

export default function RecognitionWallCard() {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [items, setItems] = useState([]);

  useEffect(() => {
    getRecognitionWall(1, MAX)
      .then((res) => {
        const list = res.data?.status ? (res.data.data?.data || []) : [];
        setItems(list.slice(0, MAX));
      })
      .catch(() => {});
  }, []);

  const goToList = () => history.push('/performance/recognitions');

  return (
    <Card $delay="0.3s">
      <ClickableHeader onClick={goToList}>
        <CardTitle>{t('recognitions.dashboardCardTitle')}</CardTitle>
        <HeaderLink>
          {t('common.seeAll') || t('dashboard.seeAll')}
          <ChevronRight size={14} />
        </HeaderLink>
      </ClickableHeader>
      {items.length === 0 ? (
        <EmptyState>
          <Award size={28} />
          {t('recognitions.dashboardCardEmpty')}
        </EmptyState>
      ) : (
        <ScrollList>
          {items.map((r) => {
            const badge = RECOGNITION_BADGE_MAP[r.badgeKey];
            const Icon = badge?.Icon || Award;
            return (
              <ListItem key={r.id}>
                <BadgeTile $from={badge?.from} $to={badge?.to}>
                  <Icon size={18} />
                </BadgeTile>
                <ListItemContent>
                  <ListItemName>{r.senderName} → {r.receiverName}</ListItemName>
                  <ListItemSub>{formatDate(r.createDate, i18n.language)}</ListItemSub>
                </ListItemContent>
              </ListItem>
            );
          })}
        </ScrollList>
      )}
    </Card>
  );
}
